import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTranslation } from 'react-i18next';

const PaginaDeErro = ({ message }) => {
  const { t } = useTranslation();

  if (!message) {
    message = "Erro desconhecido";
  }

  const partes = message.split(/Erro:|Informação adicional:|Status: |Mensagem:/).filter(Boolean);
  
  let mensagem = "";
  let erro = "";
  let informacaoAdicional = "";
  let status = "";

  if (partes.length >= 3) {
    mensagem = partes[0].trim() || "";
    erro = `Erro: ${partes[1].trim()}` || "";
    informacaoAdicional = `Informação adicional: ${partes[2].trim()}` || " ";
    status = `Status: ${partes[3].trim()}` || "";
  }

  return (
    <Paper
      elevation={3}
      sx={{
        padding: '20px',
        maxWidth: 700,
        margin: 'auto',
        marginTop: '100px',
        boxShadow:'none'
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <HighlightOffIcon sx={{ fontSize: '64px', color: '#FF0000' }} />
        <Typography variant="h5" component="h1" textAlign="center" sx={{ fontWeight: 'bold' }}>
          {t('main.mensagem-erro')}
        </Typography>
        <Typography variant="body1" component="p" textAlign="center">
          {message.length > 3 ? (
            <>
              {mensagem} <br />
              {erro} <br />
              {informacaoAdicional} <br />
              {status}
            </>
          ) : (
            <>{message}</>
          )}
        </Typography>
      </Box>
    </Paper>
  );
};

export default PaginaDeErro;
